import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { TokenRefreshService } from '../../services/token-refresh/token-refresh.service';
import { isPublicApiUrl, isPublicFrontendPath } from '../../utils/public-route.util';

/** Public auth/signup routes where 401 is an expected user error, not session expiry. */
const AUTH_ERROR_BYPASS_URLS = [
  '/v1/auth/',
  '/v1/channel-partner/auth/',
];

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenRefreshService = inject(TokenRefreshService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      if (
        AUTH_ERROR_BYPASS_URLS.some(url => req.url.includes(url)) ||
        isPublicApiUrl(req.url) ||
        isPublicFrontendPath()
      ) {
        return throwError(() => error);
      }

      return tokenRefreshService.refreshTokens(req.url).pipe(
        switchMap(newToken =>
          next(
            req.clone({
              setHeaders: { Authorization: `Bearer ${newToken}` },
            }),
          ),
        ),
        catchError(() => throwError(() => error)),
      );
    }),
  );
};
